// extracted by mini-css-extract-plugin
module.exports = {"comp":"JL_comp__xs0U6"};